import { memo } from "react";

import { CronJobExecution } from "services/api/cronjobs/types";
import { formatCronDateTime, formatDuration } from "services/api/cronjobs/transformations";

import CronJobExecutionStatusBadge from "../../../../components/CronJobExecutionStatusBadge/CronJobExecutionStatusBadge";
import DetailField from "../../../../components/DetailField/DetailField";

interface CronJobExecutionInfoCardProps {
  execution: CronJobExecution;
}

/** Zaglavlje jedne obrade: kad je krenula, kad je stala, kako je završila. */
const CronJobExecutionInfoCard: React.FC<CronJobExecutionInfoCardProps> = ({ execution }) => (
  <div className="bg-white border border-slate-200 rounded-sm p-5">
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-x-6 gap-y-5">
      <DetailField label="Status">
        <CronJobExecutionStatusBadge status={execution.status} />
      </DetailField>
      <DetailField label="Početak">{formatCronDateTime(execution.started)}</DetailField>
      <DetailField label="Kraj">{formatCronDateTime(execution.finished)}</DetailField>
      <DetailField label="Trajanje">
        {formatDuration(execution.durationSeconds)}
        {execution.status === "running" && (
          <span className="text-xs text-slate-400"> (još traje)</span>
        )}
      </DetailField>
      <DetailField label="Log zapisa">{execution.logCount}</DetailField>

      {execution.metadata && (
        <DetailField label="Metapodaci" wide>
          <pre className="font-mono text-xs bg-slate-50 border border-slate-200 rounded p-3 whitespace-pre-wrap break-all">
            {execution.metadata}
          </pre>
        </DetailField>
      )}
    </div>
  </div>
);

export default memo(CronJobExecutionInfoCard);
